<template>
  <section id="viajes" class="servicios-viaje">
    <div class="contenedor-viaje">
      <!-- Información del servicio seleccionado -->
      <div class="info-viaje">
        <h2>SERVICIOS MÁS POPULARES</h2>

        <p>
          Descubre los seguros que más confianza generan entre nuestros
          clientes. Cada uno está diseñado para proteger lo que más valoras y
          brindarte la tranquilidad de estar respaldado en todo momento.
        </p>

        <div class="info-dinamica">
          <h3>{{ currentCard.titulo }}</h3>

          <p>{{ currentCard.descripcion }}</p>

          <button
            type="button"
            class="btn btn-primary"
            @click="irAFormulario"
          >
            Más información
          </button>
        </div>
      </div>

      <!-- Carrusel -->
      <div class="carrusel-fijo">
        <div ref="frame" class="marco-tarjetas">
          <div
            ref="wrapper"
            class="tarjetas-wrapper"
            :style="{ transform: `translateX(-${offset}px)` }"
          >
            <div
              v-for="(card, index) in cards"
              :key="index"
              ref="cards"
              class="tarjeta-viaje"
              :class="{ activa: index === currentIndex }"
              @click="selectCard(index)"
            >
              <img
                :src="'/image/' + card.imagen"
                :alt="card.titulo"
              />

              <div class="tarjeta-overlay"></div>
            </div>
          </div>
        </div>

        <!-- Controles -->
        <div class="controles-viaje">
          <button
            type="button"
            class="btn-control prev"
            aria-label="Servicio anterior"
            @click="moveCards(-1)"
          >
            ←
          </button>

          <div class="indicadores">
            <span
              v-for="(card, index) in cards"
              :key="'indicador-' + index"
              class="indicador"
              :class="{ activo: index === currentIndex }"
              role="button"
              :aria-label="'Ver ' + card.titulo"
              @click="selectCard(index)"
            ></span>
          </div>

          <button
            type="button"
            class="btn-control next"
            aria-label="Siguiente servicio"
            @click="moveCards(1)"
          >
            →
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "TravelInsurance",

  data() {
    return {
      currentIndex: 0,
      offset: 0,
      autoPlayInterval: null,
      resizeTimeout: null,

      cards: [
        {
          titulo: "Seguro de Autos",
          descripcion:
            "Protege tu vehículo contra accidentes, robos y daños a terceros. Con un seguro de autos tendrás la seguridad de circular tranquilo y cumplir con la cobertura obligatoria en México.",
          imagen: "seguro-auto.png"
        },
        {
          titulo: "Seguro de Vida",
          descripcion:
            "Cuida el futuro de tu familia con un seguro de vida que garantiza estabilidad económica en caso de imprevistos. Una inversión accesible con gran impacto en tu tranquilidad.",
          imagen: "seguro-vida.png"
        },
        {
          titulo: "Seguro de Gastos Médicos",
          descripcion:
            "Accede a atención médica privada y de calidad sin preocuparte por altos costos hospitalarios. El seguro de gastos médicos mayores te protege frente a emergencias y tratamientos especializados.",
          imagen: "gastos-medicos.png"
        },
        {
          titulo: "Plan Privado para el Retiro",
          descripcion:
            "Construye tu patrimonio y asegura tu futuro con un plan privado de retiro. Un esquema flexible que te permite ahorrar e invertir a largo plazo para disfrutar tu jubilación con tranquilidad.",
          imagen: "plan-retiro.png"
        }
      ]
    };
  },

  computed: {
    currentCard() {
      return (
        this.cards[this.currentIndex] || {
          titulo: "",
          descripcion: "",
          imagen: ""
        }
      );
    }
  },

  mounted() {
    this.$nextTick(() => {
      this.updateOffset();
      this.startAutoPlay();
    });

    window.addEventListener("resize", this.handleResize);
  },

  beforeDestroy() {
    if (this.autoPlayInterval) {
      clearInterval(this.autoPlayInterval);
    }

    if (this.resizeTimeout) {
      clearTimeout(this.resizeTimeout);
    }

    window.removeEventListener("resize", this.handleResize);
  },

  methods: {
    selectCard(index) {
      this.currentIndex = index;
      this.updateOffset();
      this.startAutoPlay();
    },

    moveCards(direction) {
      if (!this.cards.length) return;

      let newIndex = this.currentIndex + direction;

      if (newIndex < 0) {
        newIndex = this.cards.length - 1;
      }

      if (newIndex >= this.cards.length) {
        newIndex = 0;
      }

      this.currentIndex = newIndex;
      this.updateOffset();
    },

    updateOffset() {
      this.$nextTick(() => {
        const cards = this.$refs.cards;
        const frame = this.$refs.frame;
        const wrapper = this.$refs.wrapper;

        if (
          !cards ||
          !cards.length ||
          !frame ||
          !wrapper
        ) {
          this.offset = 0;
          return;
        }

        const selectedCard = cards[this.currentIndex];
        const firstCard = cards[0];

        if (!selectedCard || !firstCard) {
          this.offset = 0;
          return;
        }

        const desiredOffset =
          selectedCard.offsetLeft - firstCard.offsetLeft;

        const maximumOffset = Math.max(
          0,
          wrapper.scrollWidth - frame.clientWidth
        );

        this.offset = Math.min(
          Math.max(desiredOffset, 0),
          maximumOffset
        );
      });
    },

    handleResize() {
      if (this.resizeTimeout) {
        clearTimeout(this.resizeTimeout);
      }

      this.resizeTimeout = setTimeout(() => {
        this.updateOffset();
      }, 100);
    },

    startAutoPlay() {
      if (this.autoPlayInterval) {
        clearInterval(this.autoPlayInterval);
      }

      this.autoPlayInterval = setInterval(() => {
        this.moveCards(1);
      }, 6000);
    },

    irAFormulario() {
      if (this.$route.path !== "/formulario_contacto") {
        this.$router.push("/formulario_contacto");
      }
    }
  }
};
</script>

<style scoped>
.servicios-viaje {
  padding: 4rem 2rem;
  background-color: #f5f7fa;
  overflow: hidden;
}

.contenedor-viaje {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  gap: 3rem;
}

.info-viaje {
  flex: 1;
  min-width: 300px;
}

.info-viaje h2 {
  margin-bottom: 2rem;
  color: #1a365d;
  font-size: 2rem;
  text-transform: uppercase;
}

.info-viaje h2,
.info-viaje h3,
.info-viaje p {
  word-break: normal;
  overflow-wrap: normal;
}

.info-viaje > p {
  line-height: 1.6;
}

.info-dinamica {
  margin-top: 2rem;
}

.info-dinamica h3 {
  margin-bottom: 1rem;
  color: #1a365d;
}

.info-dinamica p {
  line-height: 1.6;
}

.info-dinamica .btn-primary {
  margin-top: 0.75rem;
  background-color: #2b6cb0;
  border-color: #2b6cb0;
}

.carrusel-fijo {
  flex: 2;
  min-width: 0;
  position: relative;
  overflow: hidden;
}

.marco-tarjetas {
  width: calc(280px * 2 + 20px + 93px);
  max-width: 100%;
  padding-bottom: 20px;
  position: relative;
  overflow: hidden;
}

.tarjetas-wrapper {
  display: flex;
  gap: 20px;
  min-width: 0;
  transition: transform 0.5s cubic-bezier(0.25, 0.1, 0.25, 1);
  will-change: transform;
}

.tarjeta-viaje {
  width: 280px;
  height: 350px;
  flex-shrink: 0;
  position: relative;
  border-radius: 12px;
  overflow: hidden;
  background-color: white;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition:
    transform 0.3s ease,
    box-shadow 0.3s ease;
}

.tarjeta-viaje:hover {
  transform: translateY(-5px);
  box-shadow: 0 12px 25px rgba(0, 0, 0, 0.15);
}

.tarjeta-viaje img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.tarjeta-overlay {
  position: absolute;
  inset: 0;
}

.tarjeta-viaje.activa {
  border: 3px solid #2b6cb0;
}

.controles-viaje {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  margin-top: 20px;
}

.btn-control {
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 50%;
  background-color: #2b6cb0;
  color: white;
  font-size: 1.2rem;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-control:hover {
  background-color: #1a4e8a;
  transform: scale(1.1);
}

.indicadores {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.indicador {
  width: 12px;
  height: 12px;
  flex-shrink: 0;
  border-radius: 50%;
  background-color: #cbd5e0;
  cursor: pointer;
  transition: all 0.3s ease;
}

.indicador.activo {
  background-color: #2b6cb0;
  transform: scale(1.2);
}

/* =========================================
   LAPTOPS PEQUEÑAS
========================================= */

@media (max-width: 1199.98px) {
  .servicios-viaje {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .contenedor-viaje {
    gap: 2rem;
  }

  .marco-tarjetas {
    width: 100%;
  }

  .tarjeta-viaje {
    width: 250px;
    height: 330px;
  }
}

/* =========================================
   TABLETS
========================================= */

@media (max-width: 991.98px) {
  .servicios-viaje {
    padding: 3.5rem 1.5rem;
  }

  .contenedor-viaje {
    flex-direction: column;
    gap: 2.5rem;
  }

  .info-viaje {
    width: 100%;
    min-width: 0;
  }

  .info-viaje h2 {
    margin-bottom: 1.25rem;
    font-size: 1.8rem;
  }

  .info-dinamica {
    margin-top: 1.5rem;
  }

  .carrusel-fijo,
  .marco-tarjetas {
    width: 100%;
  }

  .tarjeta-viaje {
    width: calc((100% - 20px) / 2);
    height: 350px;
  }

  .controles-viaje {
    margin-top: 15px;
  }
}

/* =========================================
   CELULARES
========================================= */

@media (max-width: 767.98px) {
  .servicios-viaje {
    padding: 3rem 1rem;
  }

  .contenedor-viaje {
    gap: 2rem;
  }

  .info-viaje h2 {
    font-size: 1.65rem;
    line-height: 1.2;
  }

  .info-viaje > p {
    font-size: 0.95rem;
    line-height: 1.6;
  }

  .info-dinamica h3 {
    font-size: 1.35rem;
    line-height: 1.3;
  }

  .info-dinamica p {
    font-size: 0.93rem;
    line-height: 1.6;
  }

  .tarjetas-wrapper {
    gap: 14px;
  }

  .tarjeta-viaje {
    width: 100%;
    height: 390px;
    flex: 0 0 100%;
  }

  .tarjeta-viaje:hover {
    transform: none;
  }

  .controles-viaje {
    gap: 14px;
    margin-top: 14px;
  }

  .btn-control {
    width: 40px;
    height: 40px;
  }

  .indicadores {
    gap: 8px;
  }

  .indicador {
    width: 10px;
    height: 10px;
  }
}

/* =========================================
   CELULARES PEQUEÑOS
========================================= */

@media (max-width: 575.98px) {
  .servicios-viaje {
    padding: 2.5rem 1rem;
  }

  .info-viaje h2 {
    font-size: 1.45rem;
  }

  .info-dinamica h3 {
    font-size: 1.25rem;
  }

  .info-dinamica .btn-primary {
    width: 100%;
    min-height: 44px;
  }

  .tarjeta-viaje {
    height: 340px;
    border-radius: 10px;
  }

  .controles-viaje {
    gap: 12px;
  }

  .btn-control {
    width: 38px;
    height: 38px;
    font-size: 1rem;
  }
}

/* =========================================
   CELULARES MUY PEQUEÑOS
========================================= */

@media (max-width: 380px) {
  .servicios-viaje {
    padding-left: 12px;
    padding-right: 12px;
  }

  .info-viaje h2 {
    font-size: 1.35rem;
  }

  .tarjeta-viaje {
    height: 310px;
  }
}

/* Evita efectos hover en pantallas táctiles */
@media (hover: none) {
  .tarjeta-viaje:hover {
    transform: none;
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
  }

  .btn-control:hover {
    background-color: #2b6cb0;
    transform: none;
  }
}
</style>